import React, { useState, useRef, useEffect, useLayoutEffect } from 'react';
import { Tooltip, Text, Bubble, BubbleProps } from "tea-component";
import UpAndDown, { UpAndDownDataType } from '../UpAndDown';

import './index.scss';
interface MetricAndUpDownProps {
  metric?: string | number; // 指标数据
  maxWidth?: string | number;
  updown?: UpAndDownDataType; // 跌涨数据
  className?: string;
  style?: React.CSSProperties;
  columnNum?: number;
  hasTooltip?: boolean;
  bubble?: BubbleProps;
}

export default function MetricAndUpDown({
  metric = '',
  maxWidth: maxWidthProps = 104,
  updown,
  className,
  style,
  columnNum = 3,
  hasTooltip = true,
  bubble,
}: MetricAndUpDownProps) {
  const textRef = useRef(null);
  const [maxWidth, setMaxWidth] = useState(maxWidthProps);
  const [tooltipVisible, setTooltipVisible] = useState(false);

  const getTextWidth = () => {
    // 获取指标内容的文本宽度
    const oSpan = document.createElement('span');
    oSpan.innerText = metric;
    oSpan.style.display = 'inline-block';
    textRef?.current.appendChild(oSpan);
    const width = oSpan.clientWidth;
    textRef?.current.removeChild(oSpan);

    return width;
  };

  useEffect(() => {
    if (!hasTooltip) {
      setMaxWidth('unset');
      return;
    }
    const resetMaxWidth = () => {
      const windowWidth = window.innerWidth;
      let newMaxWiwdth = maxWidth;


      if (columnNum === 3) {
        switch (true) {
          case windowWidth <= 1436: {
            newMaxWiwdth = 60;
            break;
          }
          case windowWidth > 1920: {
            newMaxWiwdth = '46%';
            break;
          }
        }
      }
      if (columnNum === 4) {
        switch (true) {
          case windowWidth <= 1402: {
            newMaxWiwdth = 78;
            break;
          }
          case windowWidth <= 1436: {
            newMaxWiwdth = 60;
            break;
          }
          case windowWidth <= 1470: {
            newMaxWiwdth = 83;
            break;
          }
          case windowWidth <= 1530: {
            newMaxWiwdth = 94;
            break;
          }
          // case windowWidth > 1920: {
          //   newMaxWiwdth = '46%'
          //   break
          // }
        }
      }

      setMaxWidth(newMaxWiwdth);
    };
    resetMaxWidth();
    window.addEventListener('resize', () => {
      resetMaxWidth();
    });
  }, []);

  useLayoutEffect(() => {
    if (!hasTooltip) {
      setTooltipVisible(false);
      return;
    }
    const width = getTextWidth();
    setTooltipVisible(width > maxWidth);
  }, [metric, maxWidth]);

  const renderUpAndDown = () => {
    if ((metric !== '-') && (!!updown)) {
      return (
        <UpAndDown
          data={updown.data}
          status={updown.status}
        />
      );
    }
    return null;
  };

  return (
    <div
      className={`db-metrics${metric == '-' ? ' ' : ''}${className ? ` ${className}` : ''} `}
      style={style}
    >
      {metric && <Text ref={textRef} className={`db-metrics__num${(metric == '-' && (!!updown)) ? ' ' : ''} table-text`} style={{ maxWidth }} verticalAlign="middle" overflow>
        {
          (metric && tooltipVisible) ? (
            <Tooltip title={metric}>
              {metric}&nbsp;
            </Tooltip>
          ) : <>{metric}&nbsp;</>
        }

      </Text>}
      {
        bubble ? (
          <Bubble
            content={bubble.content}
            placement={bubble.placement || 'top'}
            dark={bubble.dark || true}
          >
            <div>
              {renderUpAndDown()}
            </div>
          </Bubble>
        ) : (renderUpAndDown())
      }
    </div>
  );
}
